module.exports = __webpack_public_path__ + "static/img/4.89fb0f9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/4.jpeg
// module id = 42
// module chunks = 1